<template>
  <div class="atividade-wrapper">
    <span
      ><b>{{ value.nome }}</b></span
    >
    <p v-if="value.descricao" class="descricao">{{ value.descricao }}</p>
  </div>
</template>

<script>
export default {
  name: "BaseAtividade",
  inheritAttrs: false,
  props: {
    value: Object
  }
};
</script>

<style scoped>
.atividade-wrapper p.descricao {
  white-space: pre-wrap;
}
</style>
